<template>
  <div
    class="modal-wrapper"
    :class="{
      mobileUser: mobileVersion,
      'rbxpier-search-color': $store.state.toggleSite === 'rbxpier'
    }"
  >
    <div class="modal-wrapper__block" :class="{ 'second-stage': stage === 2 }">
      <div
        class="modal-wrapper__block-close"
        :class="{
          'blue-arrow-bg': mobileVersion && $store.state.toggleSite === 'rbxpier'
        }"
        @click="$store.state.isOpenUserSearch = false"
      >
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.9436 10.1263L4.03296 1.19612C3.64183 0.805056 3.11136 0.585356 2.55823 0.585356C2.0051 0.585356 1.47463 0.805056 1.08351 1.19612C0.692386 1.58719 0.472656 2.11758 0.472656 2.67063C0.472656 3.22368 0.692386 3.75408 1.08351 4.14515L10.0149 13.0545L1.08351 21.9639C0.692386 22.355 0.472656 22.8854 0.472656 23.4384C0.472656 23.9915 0.692386 24.5219 1.08351 24.913C1.47463 25.304 2.0051 25.5237 2.55823 25.5237C3.11136 25.5237 3.64183 25.304 4.03296 24.913L12.9436 15.9828L21.8543 24.913C22.0474 25.1076 22.2771 25.2621 22.5302 25.3675C22.7833 25.473 23.0548 25.5273 23.329 25.5273C23.6032 25.5273 23.8747 25.473 24.1278 25.3675C24.3809 25.2621 24.6106 25.1076 24.8037 24.913C24.9984 24.7199 25.1529 24.4902 25.2584 24.2371C25.3638 23.9841 25.4181 23.7126 25.4181 23.4384C25.4181 23.1643 25.3638 22.8928 25.2584 22.6398C25.1529 22.3867 24.9984 22.157 24.8037 21.9639L15.8723 13.0545L24.8037 4.14515C24.9984 3.95208 25.1529 3.72239 25.2584 3.46932C25.3638 3.21624 25.4181 2.94479 25.4181 2.67063C25.4181 2.39647 25.3638 2.12503 25.2584 1.87195C25.1529 1.61888 24.9984 1.38918 24.8037 1.19612C24.6106 1.00147 24.3809 0.846964 24.1278 0.741529C23.8747 0.636093 23.6032 0.581812 23.329 0.581812C23.0548 0.581812 22.7833 0.636093 22.5302 0.741529C22.2771 0.846964 22.0474 1.00147 21.8543 1.19612L12.9436 10.1263Z"
            fill="#2F2F2F"
          />
        </svg>
      </div>
      <div
        class="modal-wrapper__block-arrow"
        :class="{
          'blue-arrow-bg': mobileVersion && $store.state.toggleSite === 'rbxpier'
        }"
        v-if="stage === 2 || error.status"
        @click="
          stage = 1;
          error.status = false;
        "
      >
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.156344 13.2928C0.255541 13.5483 0.404281 13.7818 0.594028 13.9797L11.015 24.3878C11.2094 24.5819 11.4401 24.7359 11.694 24.8409C11.9479 24.9459 12.22 25 12.4948 25C13.0498 25 13.5821 24.7798 13.9746 24.3878C14.1689 24.1937 14.3231 23.9633 14.4282 23.7097C14.5334 23.4561 14.5875 23.1843 14.5875 22.9099C14.5875 22.3555 14.367 21.8239 13.9746 21.4319L7.09673 14.5834L22.9158 14.5834C23.4686 14.5834 23.9987 14.3641 24.3896 13.9737C24.7804 13.5833 25 13.0539 25 12.5018C25 11.9497 24.7804 11.4202 24.3896 11.0298C23.9987 10.6395 23.4686 10.4202 22.9158 10.4202L7.09673 10.4202L13.9746 3.57163C14.1699 3.37812 14.325 3.14789 14.4308 2.89423C14.5366 2.64056 14.5911 2.36848 14.5911 2.09369C14.5911 1.81889 14.5366 1.54681 14.4308 1.29314C14.325 1.03948 14.1699 0.809252 13.9746 0.615739C13.7808 0.420632 13.5503 0.265768 13.2963 0.160087C13.0424 0.0544057 12.7699 -2.74551e-06 12.4948 -2.72146e-06C12.2197 -2.6974e-06 11.9472 0.0544058 11.6933 0.160087C11.4393 0.265768 11.2088 0.420632 11.015 0.615739L0.594027 11.0238C0.40428 11.2218 0.25554 11.4552 0.156344 11.7108C-0.0521132 12.2176 -0.0521132 12.786 0.156344 13.2928Z"
            fill="#2F2F2F"
          />
        </svg>
      </div>
      <div class="modal-wrapper__block-content" v-if="stage === 1 && isLoaded === true && !error.status">
        <h1>USER SEARCH</h1>
        <div class="modal-wrapper__block-content__form">
          <div class="modal-wrapper__block-content__form-label">
            <p>LOGIN/VK-ID/USER ID/EMAIL</p>
          </div>
          <div class="modal-wrapper__block-content__form-input">
            <div class="modal-wrapper__block-content__form-input__img">
              <svg width="45" height="42" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.5972 11.6354H15.5327C15.6379 11.636 15.7423 11.616 15.8397 11.5767C15.9371 11.5374 16.0258 11.4795 16.1005 11.4062L19.7634 7.78775C19.8384 7.7143 19.8979 7.62692 19.9385 7.53064C19.9791 7.43437 20 7.3311 20 7.2268C20 7.12251 19.9791 7.01924 19.9385 6.92296C19.8979 6.82669 19.8384 6.7393 19.7634 6.66586L17.828 4.7539C17.7536 4.67985 17.6652 4.62107 17.5677 4.58096C17.4703 4.54085 17.3657 4.5202 17.2602 4.5202C17.1546 4.5202 17.05 4.54085 16.9526 4.58096C16.8551 4.62107 16.7667 4.67985 16.6923 4.7539L13.0294 8.3724C12.8832 8.5238 12.8004 8.72416 12.7975 8.93334V10.8453C12.7975 11.0548 12.8817 11.2558 13.0317 11.404C13.1817 11.5521 13.3851 11.6354 13.5972 11.6354ZM14.397 9.26517L17.2602 6.43674L18.0599 7.2268L15.1968 10.0552H14.397V9.26517ZM19.1956 10.8453C18.9835 10.8453 18.7801 10.9285 18.6301 11.0767C18.4801 11.2249 18.3958 11.4258 18.3958 11.6354V17.1658C18.3958 17.3753 18.3116 17.5763 18.1616 17.7245C18.0116 17.8726 17.8082 17.9559 17.5961 17.9559H6.3993C6.18719 17.9559 5.98377 17.8726 5.83378 17.7245C5.6838 17.5763 5.59954 17.3753 5.59954 17.1658V9.57329L10.3022 14.2268C10.5254 14.4501 10.7912 14.6275 11.0843 14.7485C11.3775 14.8695 11.692 14.9319 12.0097 14.9319C12.3274 14.9319 12.6419 14.8695 12.935 14.7485C13.2281 14.6275 13.494 14.4501 13.7172 14.2268C13.8637 14.0791 13.9458 13.8805 13.9458 13.6737C13.9458 13.4669 13.8637 13.2684 13.7172 13.1207C13.6427 13.0454 13.5537 12.9856 13.4555 12.9448C13.3574 12.904 13.2519 12.883 13.1453 12.883C13.0388 12.883 12.9333 12.904 12.8351 12.9448C12.737 12.9856 12.648 13.0454 12.5735 13.1207C12.424 13.2654 12.223 13.3465 12.0137 13.3465C11.8043 13.3465 11.6033 13.2654 11.4538 13.1207L6.72721 8.4593H10.3981C10.6103 8.4593 10.8137 8.37607 10.9637 8.2279C11.1137 8.07973 11.1979 7.87878 11.1979 7.66924C11.1979 7.4597 11.1137 7.25875 10.9637 7.11058C10.8137 6.96241 10.6103 6.87917 10.3981 6.87917H6.3993C5.76297 6.87917 5.1527 7.12889 4.70274 7.57339C4.25278 8.01789 4 8.62075 4 9.24937V17.15C4 17.7786 4.25278 18.3815 4.70274 18.826C5.1527 19.2705 5.76297 19.5202 6.3993 19.5202H17.5961C18.2324 19.5202 18.8427 19.2705 19.2926 18.826C19.7426 18.3815 19.9954 17.7786 19.9954 17.15V11.6196C19.9954 11.41 19.9111 11.2091 19.7611 11.0609C19.6111 10.9127 19.4077 10.8295 19.1956 10.8295V10.8453Z"
                  fill="#2F2F2F"
                />
              </svg>
            </div>
            <input
              type="text"
              v-model="searchInput"
              @keydown.enter="getUser"
              placeholder="Enter Login/VK-ID/User ID/Email"
            />
          </div>
        </div>
        <div class="modal-wrapper__block-content__button">
          <button @click="getUser">search</button>
        </div>
      </div>
      <div class="error" v-if="error.status">
        {{ error.errorMsg }}
      </div>
      <div class="loader" v-if="isLoaded === false">
        <Loader />
      </div>
      <div
        class="user__block"
        :class="{ 'has-balance-action': $store.state.privilegedSites[$store.state.toggleSite] }"
        v-if="stage === 2 && isLoaded === true && !error.status"
      >
        <div class="user-name">
          <h1>{{ userInfo["username"] }}</h1>
          <div class="status">
            <div class="circle"></div>
          </div>
          <button
            class="pv-trigger user-name__balance"
            v-if="$store.state.privilegedSites[$store.state.toggleSite]"
            @click="openBalance"
          >
            ₽ Изменить баланс
          </button>
        </div>
        <div
          class="user__block-content__info"
          :class="$store.state.toggleSite === 'rbxpier' ? 'pier-scroll' : 'tree-scroll'"
          v-if="!error.status"
        >
          <div class="user__block-content__info-item" v-for="(item, key) in userInfo" :key="key">
            <p class="user__block-content__info-item__title">{{ fieldLabel(key) }}</p>
            <p class="user__block-content__info-item__value" v-if="key === 'user_id'">
              <IdCell :value="item" :tail="24" />
            </p>
            <p class="user__block-content__info-item__value" v-else>{{ fieldValue(item, key) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./userSearch.scss";
import "@/scss/_privileged.scss";

import CryptoJS from "crypto-js";
import hmacSHA256 from "crypto-js/hmac-sha256";

import Loader from "@/components/Loader/Loader";

export default {
  name: "UserSearch",
  components: {
    Loader
  },
  data() {
    return {
      mobileVersion: false,
      stage: 1,
      searchInput: "",
      userInfo: [],
      isLoaded: true,
      error: {
        status: false,
        errorMsg: "Пользователь не найден"
      }
    };
  },
  // zakhryapin.vs@yandex.ru
  methods: {
    fieldLabel(key) {
      return String(key).replace(/_/g, " ");
    },
    // Пустое — прочерк; объект (баланс пристани по валютам) — «175 ₽ · 0 $ · 0 €»
    fieldValue(value, key) {
      if (value === null || value === undefined || value === "") return "—";
      // vk_id: 0 — VK не привязан (is_vk не трогаем: там 0 — это код типа аккаунта)
      if (key === "vk_id" && Number(value) === 0) return "—";
      if (typeof value === "object") {
        const signs = { rub: "₽", usd: "$", eur: "€" };
        const order = Object.keys(signs);
        const rank = (currency) => (order.includes(currency) ? order.indexOf(currency) : order.length);
        return Object.entries(value)
          .sort(([a], [b]) => rank(a) - rank(b))
          .map(([currency, amount]) => `${amount} ${signs[currency] || currency.toUpperCase()}`)
          .join(" · ");
      }
      return value;
    },
    // Рублёвый баланс из verify_info: дерево — rub_balance, пристань — balance.rub (баланс по валютам)
    rubBalance() {
      const { rub_balance: rubBalance, balance } = this.userInfo;
      const value = rubBalance != null ? rubBalance : balance && balance.rub;
      return typeof value === "number" ? value : null;
    },
    openBalance() {
      this.$store.state.balanceTarget = {
        site: this.$store.state.toggleSite,
        userId: this.userInfo.user_id || "",
        username: this.userInfo.username,
        balance: this.rubBalance(),
        // Только у пристани; ручка меняет рублёвый баланс
        currency: this.userInfo.currency || null,
        onChanged: () => this.getUser()
      };
    },
    getUser() {
      if (this.searchInput) {
        this.isLoaded = false;
        this.error.status = false;
        let query = `${this.searchInput}`;
        let message = `q:${this.searchInput};v:${this.$store.state.admin_key};`;

        const key = hmacSHA256(message, this.$store.state.admin_key).toString(CryptoJS.enc.Hex);

        // console.log(key);
        if (this.$store.state.toggleSite === "rbxtree") {
          fetch(
            "https://auth.backend-tree.com/api/v1/user/verify_info?" +
              new URLSearchParams({
                q: query,
                v: key
              })
          )
            .then((res) => res.json())
            .then((data) => {
              if (data.status) {
                this.userInfo = data.data;
                this.stage = 2;
              } else {
                this.error.status = true;
              }
              // console.log(data)
              this.isLoaded = true;
            });
        }
        if (this.$store.state.toggleSite === "rbxpier") {
          fetch(
            "https://users.backend-pier.com/api/v1/user/verify_info?" +
              new URLSearchParams({
                q: query,
                v: key
              })
          )
            .then((res) => res.json())
            .then((data) => {
              if (data.status) {
                this.userInfo = data.data;
                this.stage = 2;
              } else {
                this.error.status = true;
              }
              this.isLoaded = true;
            });
        }
      }
    }
  },
  mounted() {
    if (document.body.clientWidth <= 1010) this.mobileVersion = true;
  }
};
</script>
